// Card.js
import React from "react";
import "./Card.css";

export default function Card({ title, collapsed, toggleCard, children, showChevron = true }) {
  return (
    <div className="card-wrapper">
      <div className={`card ${collapsed ? "collapsed" : ""}`}>
        <div
          className="card-header"
          onClick={showChevron ? toggleCard : undefined} // only clickable if chevron visible
          style={{ cursor: showChevron ? "pointer" : "default" }} // cursor feedback
        >
          <h4>{title}</h4>
          {showChevron && (
            <span className="chevron">
              <svg viewBox="0 0 24 24" width="22" height="22">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
              </svg>
            </span>
          )}
        </div>
        <div className="card-content">{children}</div>
      </div>
    </div>
  );
}
